import { ChatMessage } from "@/zapi-frontend/stores/chatStore";

const CHIP_OR_LEGACY_LABEL_TO_BUBBLE: Record<string, string> = {
  "I would like to proceed in English": "English",
  "日本語で進めたいと思います": "日本語",
  Japanese: "日本語"
};

export function normalizeCaseBriefLanguageUserMessages(messages: ChatMessage[]): ChatMessage[] {
  return messages.map((m) => {
    if (m.role !== "user") return m;
    const short = CHIP_OR_LEGACY_LABEL_TO_BUBBLE[m.content];
    return short ? { ...m, content: short } : m;
  });
}
